import styled from 'styled-components';
import {
  Link,
} from 'react-router';

import {
  NotificationKey,
} from '@gymcloud/core';

import {
  Flex,
  icons,
  SVG,
} from 'web-styled';

export const Header = styled(Flex).attrs({
  flex: '0 0 80px',
  align: 'center',
  justify: 'space-between',
  padding: '0 24px',
})`
  width: 100%;
  background-color: ${props => props.theme.colors.baseBanner};
`;

export const EmptyList = styled(Flex).attrs({
  fillSpace: true,
  justify: 'center',
})`
  opacity: 0.6;
  white-space: pre-line;
  text-align: center;
  width: 100%;
  height: 100px;
  margin: 50px 0;
  padding-top: 50px;
  background-image: url(${icons.workoutsSingle});
  background-repeat: no-repeat;
  background-position: top center;
`;

export const WorkoutComplete = styled(SVG.Complete).attrs(
  props => ({
    width: 20,
    height: 20,
    fill: props.theme.colors.completed,
  }),
)``;

export const WorkoutInComplete = styled(SVG.InComplete).attrs(
  props => ({
    width: 20,
    height: 20,
    fill: props.theme.colors.notCompleted,
  }),
)``;

export const LinkLabel = styled.span`
  display: flex;
  align-items: center;
  color: ${props => props.theme.colors.primary};
  text-transform: capitalize;

  &:hover {
    color: #757575;
  }
`;

export const RightSide = styled(Flex).attrs({
  column: true,
  fillSpace: true,
  spacing: 24,
})`
  padding: 41px 21px 54px;
  border-left: 1px solid rgba(40, 45, 48, 0.1);
  border-bottom: 1px solid rgba(40, 45, 48, 0.1);
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
`;

export const ActivityLink = styled(Link)`
  color: #808080;
  font-size: 13px;

  &:hover {
    color: #555;
  }
`;

type IconProps = {
  itemKey: NotificationKey;
};

export const ActivityIcon = styled(Flex).attrs({
  align: 'center',
  justify: 'center',
})<IconProps>`
  width: 24px;
  height: 24px;
  border-radius: 50%;

  &:before {
    content: '';
    background-repeat: no-repeat;
    background-size: contain;
    ${(props) => {
    switch (props.itemKey) {
      case 'workout_event.create':
      case 'workout_event.update':
      case 'activity_log.create':
      case 'activity_log.update':
        return `
            width: 12px;
            height: 12px;
            background-image:  url(${icons.activityEvent});
          `;
      case 'personal_workout.create':
      case 'personal_program.create':
        return `
            width: 10px;
            height: 11px;
            background-image: url(${icons.activityAssignedNew});
          `;
      case 'user.invitation_accepted':
        return `
            width: 12px;
            height: 12px;
            background-image: url(${icons.activityInviteAccepted});
          `;
      case 'exercise_result.create':
        return `
            width: 10px;
            height: 14px;
            background-image: url(${icons.activityEnteredResult});
          `;
      case 'comment.create':
        return `
            width: 10px;
            height: 9px;
            background-image: url(${icons.activityComment});
          `;
      case 'video.create':
        return `
            width: 24px;
            height: 24px;
            border-radius: 50%;
            background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='iso-8859-1'%3F%3E%3C!-- Generator: Adobe Illustrator 19.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E%3Csvg version='1.1' id='Capa_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 58.752 58.752' style='enable-background:new 0 0 58.752 58.752;' xml:space='preserve'%3E%3Cg%3E%3Cpath fill='%23ffffff' d='M52.524,23.925L12.507,0.824c-1.907-1.1-4.376-1.097-6.276,0C4.293,1.94,3.088,4.025,3.088,6.264v46.205 c0,2.24,1.204,4.325,3.131,5.435c0.953,0.555,2.042,0.848,3.149,0.848c1.104,0,2.192-0.292,3.141-0.843l40.017-23.103 c1.936-1.119,3.138-3.203,3.138-5.439C55.663,27.134,54.462,25.05,52.524,23.925z M49.524,29.612L9.504,52.716 c-0.082,0.047-0.18,0.052-0.279-0.005c-0.084-0.049-0.137-0.142-0.137-0.242V6.263c0-0.1,0.052-0.192,0.14-0.243 c0.042-0.025,0.09-0.038,0.139-0.038c0.051,0,0.099,0.013,0.142,0.038l40.01,23.098c0.089,0.052,0.145,0.147,0.145,0.249 C49.663,29.47,49.611,29.561,49.524,29.612z'/%3E%3C/g%3E%3C/svg%3E%0A");
            background-size: 12px;
            background-position: center;
          `;
      default:
        return '';
    }
  }}
  }

  background-color: ${(props) => {
    switch (props.itemKey) {
      case 'workout_event.create':
      case 'workout_event.update':
        return props.theme.colors.primary;
      case 'video.create':
      case 'personal_workout.create':
        return props.theme.colors.workoutCreate;
      case 'personal_program.create':
        return props.theme.colors.programCreate;
      case 'user.invitation_accepted':
        return props.theme.colors.invitationAccepted;
      case 'exercise_result.create':
        return props.theme.colors.exerciseResultCreate;
      case 'comment.create':
        return props.theme.colors.commentCreate;
      default:
        return '#808080';
    }
  }}
`;
